const offlineStates = ['offline', 'notconnected', 'Virtual'];

export default {
  methods: {
    isOwner(printerOwnershipId) {
      return printerOwnershipId == 1;
    },
    canPrint(printerOwnershipId) {
      return printerOwnershipId < 4;
    },
    canAccessAsOwner(printerOwnershipId) {
      return printerOwnershipId == 1 || (printerOwnershipId == 2 && this.$store.getters.isOrgAdmin);
    },
    getNextPrinterJobId(printerJobsList) {
      let minJobId = null;
      for (let i in printerJobsList) {
        if (minJobId === null) {
          minJobId = printerJobsList[i].job_id;
        } else if (printerJobsList[i].job_id < minJobId) {
          minJobId = printerJobsList[i].job_id;
        }
      }

      return minJobId;
    },
    calculatePrinterName(printer) {
      return printer.share_printer_name ? printer.share_printer_name : printer.real_printer_name;
    },
    buildTrayIsClear(printer) {
      return !printer.bed_not_clear && !(printer.clear_bed_notification === 't' && printer.build_tray_not_clear === 't');
    },
    isDisabledQueue(printer) {
      return (parseInt(printer.flags)&this.$store.getters.getPrintSettings.flags.disable_queue) > 0;
    },
    isDisabledPrint(printer) {
      if (!this.buildTrayIsClear && this.$store.getters.getPrintSettings.confirm_build_tray_is_empty) {
        return true;
      }
      return printer.printer_ownership_id == 3 &&
        this.$store.getters.getPrintSettings.canprint_rs&1 &&
        this.$store.getters.isPrinterHasNotFinishedJobs(printer.printer_id);
    },
    canAddToPrinterQueue(printer) {
      return printer.number_of_prints != 0;
    },
    canPrintOnPrinter(printer) {
      if (printer.state !== 'idle' || !this.canAddToPrinterQueue(printer)) {
        return false;
      }

      return (printer.number_of_prints != "undefined" && ((printer.number_of_prints == null) || (printer.number_of_prints > 0))) && printer.printer_ownership_id < 4;
    },
    isOffline(state) {
      return offlineStates.indexOf(state) >= 0;
    }
  }
}
